import React from "react";
import { useTranslation } from "react-i18next";
import { Profile } from "../../../types/types";
import { formatText } from "../../../utils/formatUtils";

interface AchievementsProps {
    member: Profile;
}

const Achievements: React.FC<AchievementsProps> = ({ member }) => {
    const { t } = useTranslation('publicProfile');
    if (!member.fighter) return null;

    return (
        <div className="space-y-4 pb-8 text-start">
            <h3 className="text-base font-semibold text-gray-800 border-b pb-2">
                {t("achievements")}
            </h3>
            <div className="space-y-3">
                {member.fighter.achievementDetails?.length ? (
                    <ol className="list-decimal list-inside space-y-2 pl-4">
                        {member.fighter.achievementDetails.map(
                            (achievement: any, index: any) => (
                                <li
                                    key={index}
                                    className="text-sm font-medium text-gray-900"
                                >
                                    {formatText(achievement.text)}
                                </li>
                            )
                        )}
                    </ol>
                ) : (
                    <p className="text-gray-500 text-center py-8">
                        {t("no_achievements")}
                    </p>
                )}
            </div>
        </div>
    );
};

export default Achievements;
